import React from 'react';
import "./styles.css";

/**
 * @function DisputeProgressWidget
 * @return {React.Component}
 * @exported true
 * @description The progress bar for the dispute transaction workflow.
 */

export default function DisputeProgressWidget(props) {
  let currStep = props.step ?? 0;
  currStep = parseInt(currStep);
  const allSteps = [0, 1, 2, 3];

  const stepComponents = allSteps.reduce((acc, step, index) => {
    if(index === currStep) {
      acc.push(<Step key={ index } classes="complete active"/>);
    } else if(index < currStep) {
      acc.push(<Step key={ index } classes="complete"/>);
    } else {
      acc.push(<Step key={ index }/>);
    }
    return acc;
  }, []);

  return(
    <div className="dispute-progress-widget">
      <div className="dispute-progress-container flex-container flex-horizontal align-center-container">
      { stepComponents }
      </div>
    </div>
  );
}

function Step(props) {
  const classes = props.classes ?? "";

  return (
    <div className={ `dispute-progress-steps flex-width ${ classes }` }></div>
  );
}